// extracted by mini-css-extract-plugin
module.exports = {"buttons":"linkbutton-module--buttons--3MULC","nomore":"linkbutton-module--nomore--2yJYY"};